import React, { useEffect, useState } from "react";

import { Modal,Button, Form } from "react-bootstrap";

import profimg from '../../../Assets/Images/profile.png'
import {NewAssetSave} from "../../../Hooks/UseBackendAction/UseCreateUser.js"

const AddAsset = (props) =>{

    const[addAsset, setaddAsset] = useState(true)
    const [tokenAddress,settokenAddress] = useState("")
    const [tokenname,settokenname] = useState("")
    const [tokensymbol,settokensymbol] = useState("")
    const [imagepath, set_imagepath] = useState("")
    const [file, set_file] = useState({})
    const [ImageURL, setImageURL] = useState("")
    const [price,setprice] = useState("")
   


    const onSubmit = async () => {

        const settingData = {
             
            tokenAddress:tokenAddress,
            name: tokenname,
            symbol:tokensymbol,
            price:price,
            file: file,
          };
         
          await NewAssetSave(settingData)
         
     };
 

     const ImageUpload = event => {
        var name = event.target.value;
        set_file(event.target.files[0]);
        set_imagepath(name);
        var url = URL.createObjectURL(event.target.files[0])
        setImageURL(url)
       
    };

    return(
        <div className="signinmodal editprofile">
                
            <Modal show={addAsset} id="assetadd"size="md" className="br-15 thememodal">
             
                <Modal.Body className="p-0 br-15">
                <button onClick={() => props.onDismiss()} className="close-btn">X</button>
                    <div className="d-flex bgblue align-items-center br-15 editprof">
                       
                        <div className=" br-15 bg-white pt-5 w-full h-44 small-input noshadow">
                            <div className="px-4">
                                <h4 className="themeclr fw-600">Add Token</h4>
                                {/* <p>Lorem hg yeg e etyegt</p> */}
                            </div>
                       
                            <hr className="themehr" />


                            <div className=" p-4">
                               
                                
                                <div className="d-lg-flex jc-between">
                                    <Form.Group className="mb-3 me-3 w-full" controlId="exampleForm.ControlInput1">
                                        <Form.Label>Asset Address</Form.Label>
                                        <Form.Control type="text" 
                                        placeholder="" 
                                        required
                                        value={tokenAddress}
                                        onChange={(e) => { settokenAddress(e.target.value) }}/>
                                    </Form.Group>
                                   
                                </div>
                                <div className="d-lg-flex jc-between">
                                    <Form.Group className="mb-3 me-3 w-full" controlId="exampleForm.ControlInput1">
                                        <Form.Label>Asset Symbol</Form.Label>
                                        <Form.Control type="text" 
                                        placeholder=""
                                        required
                                        value={tokensymbol}
                                        onChange={(e) => { settokensymbol(e.target.value) }} />
                                    </Form.Group>
                                    
                                </div>
                                <div className="d-lg-flex jc-between">
                                    <Form.Group className="mb-3 me-3 w-full" controlId="exampleForm.ControlInput1">
                                        <Form.Label>Asset Name</Form.Label>
                                        <Form.Control type="text" 
                                        placeholder=""
                                        required
                                        value={tokenname}
                                        onChange={(e) => { settokenname(e.target.value) }} />
                                    </Form.Group>
                                    
                                </div>
                                {/* <div className="d-lg-flex jc-between">
                                    <Form.Group className="mb-3 me-3 w-full" controlId="exampleForm.ControlInput1">
                                        <Form.Label>Asset Image</Form.Label>
                                        <Form.Control type="file" 
                                        placeholder=""
                                        required
                                        value={imagepath}
                                        onChange={ImageUpload} />
                                    </Form.Group>
                                    
                                </div> */}
                                <div className="d-lg-flex jc-between">
                                    <Form.Group className="mb-3 me-3 w-full" controlId="exampleForm.ControlInput1">
                                        <Form.Label>Asset Price</Form.Label>
                                        <Form.Control type="text" 
                                        placeholder=""
                                        required
                                        value={price}
                                        onChange={(e) => { setprice(e.target.value) }} />
                                    </Form.Group>
                                    
                                </div>
                                <p>Assert Image</p>
                                 <div className="editimg mb-4">
                                 {ImageURL && ImageURL.length > 0 ?
                                        <img src={ImageURL} /> : <img src ={profimg} />
                                    }
                                    <div className="fileupload">
                                        <span className="fa fa-camera" ></span>
                                        <input type="file"
                                        required
                                        accept=".jpg,.jpeg,.png"
                                            onChange={ImageUpload}
                                            value={imagepath} />
                                     </div>
                                </div>
                              

                            
                               

                            <div className="text-end mt-4">
                                <button className="btn btn-theme" onClick={() => onSubmit()}>Add</button>
                            </div>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </div>
    )
}


export default AddAsset